import "../scss/app.scss";

// SVGs to make into sprite, paths relative to app.js before move
var __svg__ = {
	path: "../svgs/sprite/*.svg",
	name: "../vibrancefestival/jinja2/svgs/sprite.svg"
};

// Polyfill all the things...
import "whatwg-fetch";
// For anything not-DOM (eg String.repeat, Promise, Array.fill etc) use core-js.
// See available options here -> https://github.com/zloirock/core-js#features
import "core-js/es/array/from";
import "core-js/features/promise";

// We manually include the DOM polyfills we believe are necesary.
import applyDomPolyfills from "./includes/dompolyfills";
import "date-input-polyfill";

applyDomPolyfills();

import { AjaxForm } from "@neonjungle/birdseed/forms/ajax";

import fileInputs from "./includes/fileinputs";
import menuActions from "./includes/menuActions";
import multiSwitcher from "./includes/multiswitcher";
import initMapOverlay from "./includes/map";
import initAccordions from "./includes/accordion";
import initProgressForm from "./includes/progressForm";
import initFileUploads from "./includes/fileUpload";

let mapOverlay = null;

window.initMap = function() {
	mapOverlay = initMapOverlay();
	mapOverlay.setupMapSpecficTriggers();
	mapOverlay.setupMapOpenTriggers();
};

document.addEventListener("DOMContentLoaded", function() {
	document.documentElement.style.setProperty(
		"--viewport-height",
		window.innerHeight + "px"
	);

	// fileInputs();
	menuActions();
	switcher();
	initAccordions();
	initProgressForm();
	initFileUploads();

	if (window.gtag) {
		const allLinks = document.querySelectorAll("a");
		allLinks.forEach($a => {
			if ($a.href.indexOf("vibrancefestival.com") === -1) {
				$a.addEventListener("click", e => {
					captureOutboundLink($a.href);
				});
			}
		});
	}
});

function captureOutboundLink(url) {
	window.gtag("event", "click", {
		event_category: "outbound",
		event_label: url,
		transport_type: "beacon"
	});
}

function switcher() {
	var sections = document.querySelectorAll("[data-switcher]");
	var triggers = document.querySelectorAll("[data-switcher-trigger]");
	if (sections.length > 0 && triggers.length > 0) {
		multiSwitcher(triggers, sections);
	}

	let mailchimpForm = document.querySelector("[data-mailchimp-form]");
	if (mailchimpForm) new AjaxForm(mailchimpForm);
}
